/* Copyright 2012 The MathWorks, Inc. */

// A gallery item may be located in one of the following three places:
define([], function () {
    return {
        GALLERY: "Gallery",
        FAVORITES: "Favorites",
        CATEGORY: "Category"
    };
});